mutation ApprovalUserActions($input: ApprovalUserActionsInput!) {
  approvalUserActions(input: $input) {
    approvalActionResults {
      entityApprovalBranchId
      userApproval {
        id
        _isUserEnMasseApprovalAllowed
        statusTypeId
        entityId
        entityApprovalBranchId
        entityApprovalBranchRowTimestamp
        displayEntityApprovalId
        requestedDate
        requiredDate
        isApproved
        approvedDate
        isRejected
        rejectedDate
        revokedDate
        approvalPersona
        _isAccountingEntryStampedCompleted
        _isExtendedNotePrivileges
        _isTransactionCancelled
        _accountingStampUserName
        _accountingStampDate
        _accountingStampTransactionReference
        additionalApprovalInformation
        _pendingApprovers
        userApprovalPhaseType {
          phaseName
        }
        approvalGroup
        userApprover {
          requesterDate
          requesterName
          approvedDate
          approvers
          rejectedDate
          rejectors
          amendedDate
          amendedByName
        }
        approvalType {
          approvalType
          id
          _isPaymentTrackingStandalone
          _isPurchaseOrderSystem
          _isTravelAuthSystem
          _isSigningStandalone
        }
        statusType {
          approvalState
          statusType
        }
        userEntityApp {
          linkType
          linkTitle
          linkHint
        }
        approvalHistorySignaturesByEntityApprovalId(orderBy: SORT_ORDER_ASC) {
          nodes {
            id
            additionalInformation
            digitalSignature
            actionDate
            isApproved
            isRejected
            isRequested
            userName
            entityDocumentId
            userSignatureDocument {
              id
              _downloadLink
              fileIndexInformation
              fileReference
              iconType
            }
          }
        }
        layoutType
        _isValidating
        iconType {
          iconType
          iconState
          isApprovalActionAvailable
        }
        verificationLinkType {
          linkRouter
          linkHint
        }
        isApprover
        isRequester
        isObserver
        isLevelBypassingAllowed
        isApproverAddingAllowed
        _isRevocable
        isRevoked
        isPending
        isHistory
        approvalBranchId
        branchStatusType {
          approvalState
          statusType
        }
        branchApprovedDate
        branchRejectedDate
        branchDigitalSignature
        approvalTreeId
        treeStatusType {
          statusType
          approvalState
        }
        companyCorporatePeriod {
          id
          _periodYear
          startDate
          endDate
        }
        treeApprovedDate
        treeRejectedDate
        description1
        description2
        description3
        description4
        description5
        digitalSignature
        date1
        amount1
        currency {
          isoCode
        }
        businessUnit {
          name
        }
        department {
          name
        }
        approvalHistoryItemsByDisplayEntityApprovalId(
          orderBy: [
            ITEM_UNIT_1_ASC
            ITEM_DESCRIPTION_1_ASC
            ITEM_DESCRIPTION_2_ASC
          ]
        ) {
          nodes {
            entityItemId
            itemDescription1
            itemDescription2
            itemDescription3
            itemDescription4
            itemDescription5
            itemAmount1
            invoiceBatchComment {
              comment
              invoice {
                _accountingStampTransactionReference
              }
            }
          }
          aggregates {
            sum {
              itemAmount1
            }
          }
        }
        _isNotesExist
        notesByEntityId (orderBy: _CREATED_DATE_DESC) {
          nodes {
            id
            noteComment
          }
        }
        _isTagsExist
        entityTagsByEntityId {
          nodes {
            id
            _tagBadgeName
          }
        }
        _isEnvironmentalsExist
        entityEnvironmentalsByEntityId {
          nodes {
            description
            startDate
            endDate
            environmentalMetric {
              id
              environmentalMetric
            }
            entityEnvironmentalItems {
              nodes {
                id
                feet
                gallons
                hours
              }
            }
          }
        }
        _isDocumentsExist
        entityDocumentsByEntityId {
          nodes {
            id
            fileReference
            iconType
            fileIndexInformation
            comment
          }
        }
      }
    }
  }
}
